/* Flight ratings: progressive enhancement of Shopify's native list filters. */
(() => {
  const bounds = {
    'filter.p.m.custom.frt_speed': [1, 15],
    'filter.p.m.custom.frt_glide': [1, 7],
    'filter.p.m.custom.frt_stability': [-5, 5],
    'filter.p.m.custom.frt_fade': [0, 5],
  };
  const numeric = value => /^-?\d+(?:\.\d+)?$/.test(value) && Number.isFinite(Number(value));
  const format = value => String(Number(value));
  let sequence = 0;
  let restoreFocus = null;

  function describe(values) {
    if (!values.length) return 'Any rating';
    const numbers = [...new Set(values.filter(numeric).map(Number))].sort((a, b) => a - b);
    const parts = [];
    for (let i = 0; i < numbers.length; i++) {
      const start = numbers[i];
      while (i + 1 < numbers.length && numbers[i + 1] - numbers[i] === 0.5) i++;
      parts.push(start === numbers[i] ? format(start) : `${format(start)}–${format(numbers[i])}`);
    }
    if (values.some(value => !numeric(value))) parts.push('Unknown');
    return parts.join(', ');
  }

  function tidy() {
    document.querySelectorAll('#FacetsWrapperDesktop, #FacetsWrapperMobile').forEach(wrapper => {
      const details = [...wrapper.querySelectorAll('.js-filter')].filter(detail => detail.querySelector('.frt-range'));
      let group = wrapper.querySelector('.frt-group');
      if (!details.length) { if (group) group.remove(); return; }
      if (!group) {
        group = document.createElement('div');
        group.className = 'frt-group';
        const id = `frt-group-${wrapper.id}`;
        group.innerHTML = `<button type="button" data-frt-toggle aria-expanded="false" aria-controls="${id}"><span>Flight ratings</span><span class="frt-group__caret" aria-hidden="true">⌄</span></button><div id="${id}" class="frt-group__content" hidden></div>`;
        group.querySelector('button').addEventListener('click', event => {
          event.stopImmediatePropagation();
          const button = event.currentTarget;
          const open = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(open));
          group.querySelector('.frt-group__content').hidden = !open;
        });
        wrapper.prepend(group);
      }
      const content = group.querySelector('.frt-group__content');
      details.sort((a,b) => Object.keys(bounds).indexOf(a.querySelector('.frt-range').dataset.key) - Object.keys(bounds).indexOf(b.querySelector('.frt-range').dataset.key));
      details.forEach((detail, index) => {
        detail.open = true;
        if (content.children[index] !== detail) content.insertBefore(detail, content.children[index] || null);
      });
    });
    const params = new URLSearchParams(location.search);
    document.querySelectorAll('.active-facets').forEach(container => {
      Object.keys(bounds).forEach(key => {
        container.querySelectorAll('facet-remove[data-frt-key]').forEach(chip => {
          if (chip.dataset.frtKey === key) chip.hidden = true;
        });
        const values = params.getAll(key);
        let chip = [...container.querySelectorAll('.frt-range-chip')].find(chip => chip.dataset.key === key);
        if (!values.length) { if (chip) chip.remove(); return; }
        const title = key.split('frt_')[1];
        const label = `${title[0].toUpperCase() + title.slice(1)}: ${describe(values)}`;
        if (!chip) {
          chip = document.createElement('button');
          chip.type = 'button'; chip.className = 'frt-range-chip'; chip.dataset.key = key;
          chip.addEventListener('click', event => {
            event.stopImmediatePropagation();
            const url = new URL(location.href); url.searchParams.delete(key); url.searchParams.delete('page');
            document.querySelector('facet-filters-form').onActiveFilterClick({preventDefault() {}, currentTarget: {href: url.href}});
          });
          container.append(chip);
        }
        if (chip.textContent !== `${label} ×`) chip.textContent = `${label} ×`;
        chip.setAttribute('aria-label', `Clear ${label}`);
      });
    });
  }

  function mount() {
    document.querySelectorAll('.js-filter').forEach(detail => {
      if (detail.querySelector('.frt-range')) return;
      const checkbox = [...detail.querySelectorAll('input[type="checkbox"]')].find(input => bounds[input.name]);
      if (!checkbox) return;
      const key = checkbox.name;
      const inputs = [...detail.querySelectorAll('input[type="checkbox"]')].filter(input => input.name === key);
      const list = detail.querySelector('.facets-wrap, .mobile-facets__list');
      if (!list) return;
      const selected = new URLSearchParams(location.search).getAll(key);
      const available = inputs.map(input => input.value).filter(numeric).map(Number);
      const numericSelected = selected.filter(numeric).map(Number);
      const min = Math.min(bounds[key][0], ...available, ...numericSelected);
      const max = Math.max(bounds[key][1], ...available, ...numericSelected);
      const low = numericSelected.length ? Math.min(...numericSelected) : min;
      const high = numericSelected.length ? Math.max(...numericSelected) : max;
      const id = `frt-${detail.id ? detail.id.replace(/[^a-zA-Z0-9_-]/g, '-') : ++sequence}`;
      const title = key.split('frt_')[1];
      const box = document.createElement('div');
      box.className = 'frt-range';
      box.dataset.key = key;
      box.frtValues = selected;
      box.innerHTML = `<div class="frt-range__title">${title[0].toUpperCase() + title.slice(1)}</div><div class="frt-range__status" role="status" aria-live="polite"></div>
        <div class="frt-range__bounds"><span>${format(min)}</span><span>${format(max)}</span></div>
        <div class="frt-range__track"><span></span>
          <input id="${id}-min" type="range" min="${min}" max="${max}" step="0.5" value="${low}" aria-label="Minimum ${title}">
          <input id="${id}-max" type="range" min="${min}" max="${max}" step="0.5" value="${high}" aria-label="Maximum ${title}">
        </div>
        <div class="frt-range__numbers"><label for="${id}-low">Min <input id="${id}-low" type="number" min="${min}" max="${max}" step="0.5" value="${low}"></label><label for="${id}-high">Max <input id="${id}-high" type="number" min="${min}" max="${max}" step="0.5" value="${high}"></label></div>
        <button type="button" class="frt-range__reset link underlined-link">Clear ${title}</button>`;
      const ranges = [...box.querySelectorAll('input[type=range]')];
      const numbers = [...box.querySelectorAll('input[type=number]')];
      const status = box.querySelector('[role=status]');
      function paint(initial = false) {
        const a = Number(ranges[0].value), b = Number(ranges[1].value);
        const span = box.querySelector('.frt-range__track span');
        span.style.left = `${100 * (a-min)/(max-min)}%`;
        span.style.right = `${100 * (max-b)/(max-min)}%`;
        ranges[0].style.zIndex = a === max ? '4' : '2';
        status.textContent = box.frtValues.length ? `Selected: ${describe(box.frtValues)}` : 'Any rating';
        ranges.forEach((input, i) => input.setAttribute('aria-valuetext', format(input.value)));
      }
      function update(index, value) {
        let number = Math.max(min, Math.min(max, Math.round(Number(value)*2)/2));
        number = index === 0 ? Math.min(number, Number(ranges[1].value)) : Math.max(number, Number(ranges[0].value));
        ranges[index].value = numbers[index].value = number;
        // Enumerate the entire interval so zero-count values cannot narrow it.
        box.frtValues = [];
        for (let n = Number(ranges[0].value)*2; n <= Number(ranges[1].value)*2; n++) box.frtValues.push(format(n/2));
        paint();
      }
      function submit(event) {
        restoreFocus = event.target.id || null;
        const form = box.closest('facet-filters-form');
        form.onSubmitHandler({ preventDefault() {}, target: event.target, srcElement: event.target });
      }
      // Do not let the native debounced input handler submit while dragging.
      box.addEventListener('input', event => event.stopPropagation());
      ranges.forEach((input, i) => {
        input.addEventListener('input', () => update(i, input.value));
        input.addEventListener('change', submit);
      });
      numbers.forEach((input, i) => input.addEventListener('change', event => {
        if (input.value === '' || !Number.isFinite(Number(input.value))) { input.value = ranges[i].value; return; }
        update(i, input.value); submit(event);
      }));
      box.querySelector('button').addEventListener('click', event => {
        event.stopImmediatePropagation();
        box.frtValues = []; ranges[0].value = numbers[0].value = min; ranges[1].value = numbers[1].value = max;
        paint(); submit(event);
      });
      detail.classList.add('frt-enhanced');
      if (list.classList.contains('facets-wrap')) list.prepend(box); else list.before(box);
      paint(true);
    });
    tidy();
    if (restoreFocus) {
      const input = document.getElementById(restoreFocus);
      if (input) { input.focus({ preventScroll: true }); restoreFocus = null; }
    }
  }

  // Keep all unrelated form fields; only replace the four exact rating parameters.
  window.frtSearchParams = (form, params) => {
    if (!['FacetFiltersForm', 'FacetFiltersFormMobile'].includes(form.id)) return params;
    const url = new URLSearchParams(location.search);
    ['preview_theme_id', '_fd', 'pb'].forEach(key => {
      if (!params.has(key) && url.has(key)) params.set(key, url.get(key));
    });
    Object.keys(bounds).forEach(key => {
      const control = [...form.querySelectorAll('.frt-range')].find(box => box.dataset.key === key);
      const values = control ? control.frtValues : url.getAll(key);
      params.delete(key);
      values.forEach(value => params.append(key, value));
    });
    return params;
  };
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('menu-drawer > details[open]')) {
      event.target.querySelectorAll('.frt-enhanced').forEach(detail => { detail.open = true; });
    }
  }, true);
  mount();
  let pending = false;
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !node.closest?.('.frt-range')))) return;
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; mount(); });
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
